module.exports = {
    'selectLanguage': 'Selecione o seu idioma',
    'Terms of Service': 'Impressum',
    'Privacy Policy': 'Datenschutz',
    'subscribe': 'Abbonieren',
    'email': 'E-Mail',
};